var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgPlayCircle = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z",
    stroke: props.color || 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99992 17C8.83795 17 8.67596 16.961 8.52796 16.882C8.20299 16.7081 8 16.369 8 16.0001V8.00064C8 7.63266 8.20299 7.29369 8.52796 7.1187C8.85194 6.94371 9.24694 6.96371 9.55492 7.1687L15.5545 11.1684C15.8324 11.3544 15.9994 11.6664 15.9994 12.0003C15.9994 12.3353 15.8324 12.6463 15.5545 12.8323L9.55492 16.832C9.38691 16.943 9.19295 17 8.99992 17Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgPlayCircle;